import { render, staticRenderFns } from "./GuestInfoPolicy.vue?vue&type=template&id=d04e90d2&scoped=true"
import script from "./GuestInfoPolicy.vue?vue&type=script&lang=js"
export * from "./GuestInfoPolicy.vue?vue&type=script&lang=js"
import style0 from "./GuestInfoPolicy.vue?vue&type=style&index=0&id=d04e90d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04e90d2",
  null
  
)

export default component.exports